import './CarouselCard.css';
import './CustomCard.css';
import {Button} from '@deere/ux.uxframe-react';
import React from 'react';

const CustomCard = (props) => {
  return (
    <div key={props.reactKey} className={`customCardWrapper ${props?.class}`}>
      {props.bgImg && (
        <div className="customCardBgImg">
          <img src={props.bgImg} />
        </div>
      )}
      <div className={props.cardHeadClassName ? props.cardHeadClassName : ''}>
        {props.cardHead && (
          <div className={`customCardHead ${props.cardHeadInnerClassName}`}>
            {props.cardHead}
          </div>
        )}
        {props.cardBody && (
          <div className={`customCardBody ${props.cardBodyClassName}`}>
            {props.cardBody}
          </div>
        )}
        {props.cardFooter && (
          <div className={`customCardFooter ${props.cardFooterClassName}`}>
            {props.cardFooter}
          </div>
        )}
        {props.cardButton && (
          <Button variant="primary" className="carouselCardButton">
            {props.cardButton.text}
          </Button>
        )}
      </div>
    </div>
  );
};

export default CustomCard;
